module.exports = __webpack_public_path__ + "static/media/colosseum.bbdb83e9.jpg";